export const environment = {
    production: false,
    createCampaigns: 'https://api-staging.bancodebogota.co/credito//campaign-admin/campaigns-create',
    uploadCampaigns: 'https://dzkstw7y8i.execute-api.us-east-1.amazonaws.com/stage/upload',
    executeUploadCampaigns: 'https://api-staging.bancodebogota.co/credito//campaign/input-data?product=',
    disabledCampaigns: 'https://api-staging.bancodebogota.co/credito//campaign-admin/campaigns-disabled'
};
